import request from '../../axios';
import {AxiosRequestConfig} from 'axios';
import {cleanFields} from '../../../utilities/helper/cleanFields';

export const getAddressByTitleSearch = async (textSerach: string) => {
  const payload = {
    searching_title: textSerach.trim(),
  };

  const {data}: {data: IAddressByTitleSerach} = await request.get(
    `/api/v2/store/title-based-search`,
    {
      params: cleanFields(payload),
    } as AxiosRequestConfig,
  );
  return data;
};
